"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserProfileResponseApiSchema = void 0;
const zod_1 = require("zod");
const doctor_substitute_1 = require("../doctor-substitutes/doctor-substitute");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
const get_me_1 = require("./get-me");
const user_1 = require("./user");
exports.updateUserProfileResponseApiSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('users'),
        attributes: zod_1.z.object({
            email: zod_1.z.string().email(),
            picture: profile_schema_1.pictureSchema,
            role: user_1.userRoleSchema,
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            phoneNumber: zod_1.z.string().nullable().default(null),
            createdAt: zod_1.z.coerce.date(),
        }),
        relationships: zod_1.z
            .object({
            doctorSubstitute: (0, api_1.apiEntityRelationshipSchema)('doctor-substitutes').optional(),
            doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings').optional(),
        })
            .optional(),
    }),
    included: zod_1.z
        .array(zod_1.z.union([
        doctor_substitute_1.doctorSubstituteApiRelationSchema,
        get_me_1.doctorAttendingApiRelationSchema,
    ]))
        .optional()
        .default([]),
});
